import { useLocation, Link } from 'react-router-dom';

const routePathNameMap = {
  '/app': 'Dashboard', // or 'Home'
  '/app/dashboard': 'Dashboard',
  '/app/Admindetails': 'Admin Management',
  '/app/addadminuser': 'Add Admin User',
  '/app/adduser': 'Add User',
  '/app/addappuser': 'Add Participant',
  '/app/addfaculty': 'Add Faculty',
  '/app/audittrail': 'Audit Trail',
};

function Breadcrumbs() {
  const location = useLocation();
  const rawPathnames = location.pathname.split('/').filter(Boolean);

  const pathSegments = [];
  rawPathnames.forEach((segment, index) => {
    const path = `/${rawPathnames.slice(0, index + 1).join('/')}`;
    pathSegments.push(path);
  });

  return (
    <nav className="text-sm text-gray-600 px-4 py-2 rounded">
      <ol className="flex flex-wrap items-center space-x-2">
        {pathSegments.map((path, index) => {
          const label = routePathNameMap[path] || path.split('/').pop();
          const isLast = index === pathSegments.length - 1;

          return (
            <li key={path} className="flex items-center">
              {index !== 0 && <span className="mx-2">/</span>}
              {isLast ? (
                <span className="text-gray-500">{label}</span>
              ) : (
               <Link to={path} className="text-[#900028] hover:underline">

                  {label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export default Breadcrumbs;
